import { FC } from 'react';

import Loader from '@components/common/Loader';
import { oytserLanding } from '@configs/variables';
import AuthorizedHandler from '@containers/checkout/payment-form/CardPaymentForm/FiservCardForm/AuthorizedHandler';
import PopupWindowHandler from '@containers/checkout/payment-form/CardPaymentForm/FiservCardForm/PopupWindowHandler';
import getUrlParam from '@utils/getUrlParam';

const Processing: FC = () => {
  const acsURLParam = getUrlParam('acsURL');
  const cReqURLParam = getUrlParam('cReq');
  const authorizedURLParam = getUrlParam('authorization');

  if (authorizedURLParam) {
    return <AuthorizedHandler authorizedURLParam={authorizedURLParam} />;
  }
  if (acsURLParam && cReqURLParam) {
    return <PopupWindowHandler acsURL={acsURLParam} cReq={cReqURLParam} />;
  }

  window.location.replace(oytserLanding);
  return <Loader />;
};

export default Processing;
